import { LayerGroup, Marker, Popup } from "react-leaflet";
import { TPGeofield, TPMapItem } from "../../interfaces/TPMap";
import { accommodationIcon, attractionIcon, defaultIcon, natureIcon, restaurantIcon, secretIcon, spaceIcon, touristOfficeIcon, touristServiceIcon, townIcon, wineryIcon, wineShopIcon } from "../../interfaces/Icons";
import L from 'leaflet';
import MarkerClusterGroup from "react-leaflet-markercluster";

interface MapsGroupItemsRenderProps {
    items: TPMapItem[];
}
export default function MapsGroupItemsRender(props: MapsGroupItemsRenderProps) {
    return (<LayerGroup>
                <MarkerClusterGroup>
                    { props.items.map((i: TPMapItem) => {
                        return i.location.map((l: TPGeofield) => {
                            if (l.geo_type == 'Point') {
                                let icon: L.Icon = defaultIcon;
                                console.log(i);
                                switch (i.type) {
                                    case 'accommodation':
                                        icon = accommodationIcon;
                                        break;
                                    case 'restaurant':
                                        icon = restaurantIcon;
                                        break;
                                    case 'wine_cellar_or_cava':
                                        icon = wineryIcon;
                                        break;
                                    case 'wine_shop':
                                        icon = wineShopIcon;
                                        break;
                                    case 'tourist_service':
                                        icon = touristServiceIcon;
                                        break;
                                    case 'attraction':
                                        icon = attractionIcon;
                                        break;
                                    case 'town':
                                        icon = townIcon;
                                        break;
                                    case 'tourist_office':
                                        icon = touristOfficeIcon;
                                        break;
                                    case 'nature':
                                        icon = natureIcon;
                                        break;
                                    case 'secret':
                                        icon = secretIcon;
                                        break;
                                    case 'space':
                                        icon = spaceIcon;
                                        break;
                                } 
                                return (<Marker position={[l.lat, l.lon]} icon={ icon }>
                                    <Popup>
                                        <div className="map-popup-content">
                                            { i.image &&
                                                <div className="image">
                                                    <img src={ i.image } alt={ i.name } />
                                                </div>
                                            }
                                            <div className="name">
                                                { i.name }
                                            </div>
                                        </div>
                                    </Popup>
                                </Marker>);
                            }
                        });
                    })}
                </MarkerClusterGroup>
        </LayerGroup>);
}